import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/internal/operators/map';
import { ErrorCode } from '../constants/error-code';

const routes = {
  branch: (id: number) => `/enterprises/${id}`,
  updateBranch:  (id: number) => `/enterprises/update/${id}`,
  allBranchesAndParentEnterprises: (currentEnterpriseId: string) => `/enterprises/group/${currentEnterpriseId}`
};

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  constructor(
    private apiService: ApiService
  ) { }

  filterBranches(filter: any) {
    return this.apiService.postSilently('/enterprises/branchs/filter', filter)
      .pipe(map(res => {
        return res;
      }));
  }

  createBranch(enterprise: any, noCallBack: any, errCallback: any) {
    return this.apiService.post('/enterprises/branch/' + enterprise.parentId, enterprise)
      .pipe(map(res => {

        if (errCallback && !res.success) {
          errCallback(res);
        } else if (res && (res.code === ErrorCode.CertificateCodeDuplicate || res.code === ErrorCode.TaxCodeDuplicate)) {
          noCallBack(res.code);
        }
        return res;
      }));
  }

  getParentBranches(parentId: any) {
    return this.apiService.get('/enterprises/child/' + parentId)
      .pipe(map(res => {
        return res;
      }));
  }

  getBranch(id: any) {
    return this.apiService.get(routes.branch(id))
      .pipe(map(res => {
        return res;
      }));
  }

  updateBranch(enterprise: any, callBack: any, noCallBack: any, errCallback: any) {
    return this.apiService.putAndCheckVersion(
      routes.updateBranch(enterprise.id),
      enterprise,
      callBack,
      noCallBack,
      errCallback
    );
  }

  changeBranchStatus(id: any) {
    return this.apiService.get('/enterprises/change-status/' + id)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get all branches and parent enterprises of current logged in enterprise
   */
  getAllBranchesAndParentEnterprises(currentEnterpriseId: string) {
    return this.apiService.get(routes.allBranchesAndParentEnterprises(currentEnterpriseId))
      .pipe(map(res => {
        return res;
      }));
  }
}
